import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { IWorkflowNode } from "../Entity/IWorkflowNode";
import { SortVisibleNodes } from "./SortVisibleNodes";

/**
 * Get all non-collapsed child nodes (recursively), and include the root node
 */
export async function GetAllVisibleNodesAsync(rootNode: IWorkflowNode) {
    const visibleNodes = await MotwLogicServer.GetVisibleNodesAsync(
        rootNode.id
    );

    const sorted = SortVisibleNodes(visibleNodes, rootNode.options?.customSorter);

    return sorted;
}
